"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SectionHeader = props => {
  var classes = (0, _styles.default)(props);
  var {
    title,
    size = 'large'
  } = props;
  var getTitleSizeVariant = () => {
    if (size === 'small') {
      return 'subtitle1';
    } else if (size === 'medium') {
      return 'h6';
    } else {
      return 'h5';
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: getTitleSizeVariant(),
    className: classes.titleText
  }, title));
};
var _default = exports.default = SectionHeader;